"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StrategiesSelection = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reduxForm = require("redux-form");
var _reactRedux = require("react-redux");
var _reactI18next = require("react-i18next");
var _useFormValues2 = require("../../hooks/useFormValues");
var _cssClassesHelper = require("../../../../helpers/cssClassesHelper");
var _FormItem = require("../../../form/FormItem");
var _APReactSelect = _interopRequireDefault(require("../../../common/APReactSelect/APReactSelect"));
require("./StrategiesSelection.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('strategies');
var StrategiesSelection = exports.StrategiesSelection = function StrategiesSelection(_ref) {
  var _timeInForceOptions$;
  var formName = _ref.formName,
    timeInForceOptions = _ref.timeInForceOptions;
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useTranslation = (0, _reactI18next.useTranslation)('order'),
    t = _useTranslation.t;
  var _useFormValues = (0, _useFormValues2.useFormValues)(formName),
    orderType = _useFormValues.orderType,
    postOnly = _useFormValues.postOnly,
    priceOrderType = _useFormValues.priceOrderType;
  var defaultTimeInForceValue = timeInForceOptions === null || timeInForceOptions === void 0 || (_timeInForceOptions$ = timeInForceOptions[0]) === null || _timeInForceOptions$ === void 0 ? void 0 : _timeInForceOptions$.value;
  (0, _react.useEffect)(function () {
    if (postOnly) {
      dispatch((0, _reduxForm.change)(formName, 'timeInForce', defaultTimeInForceValue));
    }
  }, [postOnly, dispatch, formName, defaultTimeInForceValue]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses()
  }, formName === 'futuresOrderEntry' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('strategies-item')
  }, /*#__PURE__*/_react["default"].createElement(_FormItem.RFormButtonToggle, {
    size: "xs",
    variant: "secondary",
    className: baseClasses('strategies-checkbox'),
    name: "TPSL",
    label: t('TP/SL')
  })), orderType === 'Conditional' ? /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('strategies-item')
  }, /*#__PURE__*/_react["default"].createElement(_FormItem.RFormButtonToggle, {
    size: "xs",
    variant: "secondary",
    className: baseClasses('strategies-checkbox'),
    name: "closeOnTrigger",
    label: t('Close on Trigger')
  })) : /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('strategies-item')
  }, /*#__PURE__*/_react["default"].createElement(_FormItem.RFormButtonToggle, {
    size: "xs",
    variant: "secondary",
    className: baseClasses('strategies-checkbox'),
    name: "reduceOnly",
    label: t('Reduce')
  }))), orderType !== 'Market' && (orderType !== 'Conditional' || priceOrderType !== 'Market') && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('strategies-item')
  }, /*#__PURE__*/_react["default"].createElement(_FormItem.RFormButtonToggle, {
    size: "xs",
    variant: "secondary",
    className: baseClasses('strategies-checkbox'),
    label: t('Post'),
    name: "postOnly"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('strategies-item')
  }, /*#__PURE__*/_react["default"].createElement(_APReactSelect["default"], {
    name: "timeInForce",
    customClass: baseClasses('time-in-force-select'),
    options: timeInForceOptions,
    isSearchable: false,
    valueAsObject: false,
    disabled: postOnly
  }))));
};